import { Badge, Box, HStack } from '@chakra-ui/react';

import { Text } from 'components/v4';

function getFailureReason(message) {
    return message?.replace(/\[Failed]\s*/g, '').trim();
}

function ChunkResultItem({ item, darkMode }) {
    const failureReason = item.isError ? getFailureReason(item.message) : '';

    return (
        <Box
            px={3}
            py={2}
            borderRadius="md"
            bg={
                item.isError
                    ? darkMode
                        ? 'rgba(254,178,178,0.16)'
                        : 'red.50'
                    : darkMode
                      ? 'rgba(154,230,180,0.16)'
                      : 'green.50'
            }>
            <HStack justify="space-between">
                <Text fontSize="sm" color={darkMode ? 'gray.100' : 'gray.700'}>
                    {item.number} — Block size: {item.blockSize}
                </Text>
                <Badge
                    borderRadius="full"
                    variant="subtle"
                    textTransform="capitalize"
                    px={2.5}
                    py={0.5}
                    colorScheme={item.isError ? 'red' : 'green'}>
                    {item.isError ? 'Failed' : 'Success'}
                </Badge>
            </HStack>
            {failureReason && (
                <Text
                    fontSize="xs"
                    color={darkMode ? 'red.200' : 'red.500'}
                    mt={1}>
                    {failureReason}
                </Text>
            )}
        </Box>
    );
}

export { ChunkResultItem };
